// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"4a00e30b","427":"6f715994","453":"21563b61","979":"ea7adc00"}[chunkId] + ".chunk.js";
};